import { colorLayer, eyelashLayer, eyelinerLayer } from './labMakeupSchema';

const FINISH_LABELS = {
  matte: 'Matte',
  satin: 'Satin',
  glossy: 'Glossy',
  gloss: 'Glossy',
  shimmer: 'Shimmer',
  metallic: 'Metallic',
  dewy: 'Dewy',
  sheer: 'Sheer',
  natural: 'Natural',
};

function finishParts(finish) {
  const t = String(finish || 'satin').toLowerCase();
  return { finishType: t, finishName: FINISH_LABELS[t] || 'Satin' };
}

function mapCategory(studioCat) {
  if (studioCat === 'eyebrow') return 'eyebrows';
  if (studioCat === 'eyelashes') return 'eyelash';
  return studioCat;
}

/** Convert Makeup Studio v2 resolved `makeup` object → FLUX lab layers (hex + names in prompt). */
export function studioMakeupToLab(studioMakeup) {
  if (!studioMakeup || typeof studioMakeup !== 'object') return {};
  const out = {};
  for (const [cat, layer] of Object.entries(studioMakeup)) {
    if (!layer || typeof layer !== 'object') continue;
    const intensity = Number(layer.intensity) || 0;
    if (intensity <= 0) continue;
    const key = mapCategory(cat);
    const finish = finishParts(layer.finish);

    if (key === 'eyeliner') {
      const tpl = layer.template || layer.style || 'minimal_tightline';
      out[key] = eyelinerLayer(
        layer.style_name || layer.color_name || 'Eyeliner',
        tpl,
        layer.color_name || 'Brown',
        layer.color || '#3B1F14',
        intensity,
      );
      continue;
    }
    if (key === 'eyelash') {
      const tpl = layer.template || layer.style || 'natural';
      out[key] = eyelashLayer(
        layer.style_name || 'Natural',
        tpl,
        layer.color_name || 'Soft Black',
        layer.color || '#2B2B2B',
        intensity,
      );
      continue;
    }

    const hex = layer.color || (Array.isArray(layer.colors) ? layer.colors[0] : null);
    const name =
      layer.color_name ||
      (Array.isArray(layer.color_names) ? layer.color_names[0] : null) ||
      layer.family ||
      'Matched';
    out[key] = colorLayer(name, hex, intensity, finish);
  }
  return out;
}
